import { render, staticRenderFns } from "./List-Distribution-Center-Link-Tab.vue?vue&type=template&id=4d439e9b"
import script from "./List-Distribution-Center-Link-Tab.vue?vue&type=script&lang=js"
export * from "./List-Distribution-Center-Link-Tab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports